export default __webpack_public_path__ + "static/media/dreamscape_account_educators.dc90bd69.png";